import React from 'react'
import { cx } from '@/lib/utils'
import styles from './FormAlert.module.scss'

type Variant = 'success' | 'error'

interface FormAlertProps {
  message: string
  variant: Variant
}

const variantMap: Record<Variant, string> = {
  success: styles.success, error: styles.error,
}

export const FormAlert: React.FC<FormAlertProps> = ({ message, variant }) => (
  <div className={cx(styles.alert, variantMap[variant])}>{message}</div>
)
